export const GTM = {
	trackEvent(payload, override = false) {
		window.dataLayer = window.dataLayer || [];

		// Find the index of an existing event with the same name
		const existingIndex = window.dataLayer.findIndex(
			(item) => item.event === payload.event,
		);
		if (override && existingIndex !== -1) {
			// If found, replace the existing entry
			window.dataLayer[existingIndex] = payload;
		} else {
			// If not found, add the new entry
			window.dataLayer.push(payload);
		}
	},
};
